module.exports = __webpack_public_path__ + "fonts/HalisR-Medium.d2c61bf1.otf";